import React from "react";
import { Navigate } from "react-router-dom";
import { useWebChat } from "../context/webChatContext";

const PrivateRoute = ({ children }: any) => {
  const { isAuthenticated } = useWebChat();

  if (isAuthenticated === null) {
    return;
  }

  if (!isAuthenticated) {
    return <Navigate to="/otp-login" />;
  }

  return children;
};

export default PrivateRoute;
